import React from "react";
import { connect } from "react-redux";
//import $ from 'jquery'
import { store } from "../_helpers";
import ModalNotificaciones from "../_common/ModalNotificaciones";
import { Table, Divider, Tag, Icon, notification } from 'antd';
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from "react-device-detect";
import { database } from "../init-fcm";
import axios from "axios";
import { adminuserActions } from "../_actions";
import { notificacionsActions } from "../_actions";
import './Usuarios.css';
import "react-tabs/style/react-tabs.css";
import { withRouter } from 'react-router-dom';
import {
  Badge,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
  Card,
  CardImg,
  ButtonToolbar,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  FormCheckbox,
  Container,
  FormTextarea,
  CardHeader,
  Form,
  FormGroup,
  FormInput,
  FormSelect,
  ButtonGroup
} from "shards-react";
import PageTitle from "../_components/PageTitle";

class NotificacionesListado extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      nav_number: 0,
      cons: false,
      perm: false,
      id_user: 0,
      permisos_usados: {},
      dealers_usados: {},
      modal_id: undefined
    };

    this.toggle = this.toggle.bind(this);
    this.set_coso = this.set_coso.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentWillMount() {
    this.props.getNotifications();
  }

  closeModal() {
    this.setState({
      modal_id: undefined
    });
    
  }

  routeChange(person) {
    
    if(person.leido == false) {
      database.ref('notificaciones/notificacion_' + person.id).set({
        ...person, leido: true
      });
    }

    const datosx  = JSON.parse(localStorage.getItem('user'));

    const userr_id = datosx.user.id;

    axios({
      method: "get",
      url:
        "https://nuestrosautos.cca.org.ar/notificaciones/leer/" + person.id + "/" + userr_id + "?token=" + store.getState().authentication.user.token
    }).then(response => {
      let path = "/consultas/view/" + person.id;
      this.props.history.push(path);
    });
  }


  mostrar_coso(person) {

    this.setState({
      modal_id: undefined
    });

    if(this.state.modal_id == undefined) { 
      
      if(person.leido == false) {
        database.ref('notificaciones/notificacion_' + person.id).set({
          ...person, leido: true
        });
      }
  
      const datosx  = JSON.parse(localStorage.getItem('user'));
  
      const userr_id = datosx.user.id;
  
      axios({
        method: "get",
        url:
          "https://nuestrosautos.cca.org.ar/notificaciones/leer/" + person.id + "/" + userr_id + "?token=" + store.getState().authentication.user.token
      }).then(response => {
        this.setState({
          modal_id: person
        });
      });

      

  }
  }

  set_coso(item) {
    this.setState({
      modal_id: item
    });

    if(this.state.modal_id != undefined) {
        console.log('pex')
    }

     }



  toggle() {
    this.setState({
      open: !this.state.open
    });
  }

  render() {
    const { open } = this.state;

    const columns = [
      {
        title: '#',
        dataIndex: 'id',
        key: 'id',
        sorter: (a, b) => a.id.localeCompare(b.id),
      },
      {
        title: 'Nombre',
        dataIndex: 'title',
        key: 'title',
        sorter: (a, b) => a.title.localeCompare(b.title),
      },
      {
        title: 'Tipo',
        dataIndex: 'type',
        key: 'type',
        sorter: (a, b) => a.type.localeCompare(b.type),
      },
      {
        title: 'Fecha',
        dataIndex: 'date',
        key: 'date',
        sorter: (a, b) => a.date.localeCompare(b.date),
      },
      {
        title: 'Leído',
        dataIndex: 'leido',
        key: 'leido',
        render: text => {
          //console.log(text)
          if(text == null) {
            return 'No Leído';
          }else{
            return 'Leído';
          }
        }
      },
      {
        title: 'Acción',
        dataIndex: 'accion',
        key: 'accion',
        render: (text, data) => (
          <td className="pof" style={{padding: '0.45rem !important'}}>
            {data.type != 'message' ? (
              <i className="material-icons" title="Ver detalles" style={{cursor: 'pointer', display: 'inline', fontSize: '23px'}} onClick={() => {this.mostrar_coso(data)}}>visibility</i>
            ):(
              <i className="material-icons" title="Ver conversación" style={{cursor: 'pointer', display: 'inline', fontSize: '23px'}} onClick={() => this.routeChange(data)}>visibility</i>
            )}
        </td>
        )

      },
    ];

     

    var data = [
      this.props.notifications.list.map((item,i) => (
      {
        id: item.id,
        title: item.title,
        type: item.type,
        date: item.created_at,
        leido: item.id_lectura,
        destino: item.destino,
        accion: item.id,
        // For modal
        selectedTitle: item.title,
        selectedBody: item.text,
        selectedDate: item.created_at,
        selectedButton: item.button,
        selectedButton_for: item.button_for,
        selectedButton_id: item.id,
        selectedButton_api: item.button_api,
      })),
    ];   

    return (
      <div>
        <>
          <Row noGutters className="page-header py-4" style={{ width: "100%" }}>
            <PageTitle sm="4" title="Notificaciones" className="text-sm-left" />
            <Col sm="6">
           
            </Col>
            <Col sm="2">
            
            </Col>
          </Row>

          <Row>
            <Col>
              <Card small className="mb-4">
                
                <CardBody className="p-0 pb-3">

                   <div class="table-responsive">
            <Table columns={columns} locale={{ emptyText: 'Obteniendo datos...' }} dataSource={data[0]} pagination={false} />
            </div>

      
                  {this.state.modal_id != undefined && this.state.modal_id != 'edit'? (
                            <ModalNotificaciones closeModal={() => this.closeModal()} open={true} data={this.state.modal_id}></ModalNotificaciones>
                        ) : (
                            <div></div>
                        )}
                </CardBody>
              </Card>
            </Col>
          </Row>

         

          <br />
          <br />
        </>
      </div>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      
    );
  }
}

function mapState(state) {
  const { users, authentication, vehicles, adminuser, notifications } = state;

  const { user } = authentication;
  console.log("estox ->", notifications);

  return { user, users, adminuser, notifications };
}

const actionCreators = {
  getNotifications: notificacionsActions.getNotifications
};

const connectedUsuarios = withRouter(connect(
  mapState,
  actionCreators
)(NotificacionesListado));
export { connectedUsuarios as NotificacionesListado };
  